import { logger } from '@/utils/logger';

import React from 'react';
import { Button } from '@/components/ui/button';
import EmailInput from './EmailInput';

interface ForgotPasswordFormProps {
  email: string;
  setEmail: (email: string) => void;
  isLoading: boolean;
  rememberEmail: boolean;
  handleRememberEmail: (checked: boolean) => void;
  onPasswordReset: () => Promise<void>;
  toast: any;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  email,
  setEmail,
  isLoading,
  rememberEmail,
  handleRememberEmail,
  onPasswordReset,
  toast
}) => {
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await onPasswordReset();
    } catch (error: any) {
      logger.error('Password reset error:', error);
      toast({
        title: "Password reset failed",
        description: error.message || "An unexpected error occurred.",
        variant: "destructive"
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <EmailInput
        email={email}
        setEmail={setEmail}
        rememberEmail={rememberEmail}
        onRememberChange={handleRememberEmail}
        showRememberOption={false}
      />

      <Button
        type="submit"
        className="w-full"
        disabled={isLoading}
      >
        {isLoading ? 'Sending...' : 'Send Reset Email'}
      </Button>
    </form>
  );
};

export default ForgotPasswordForm;
